import * as React from 'react';

import classnames from 'classnames';

import type {DeltaMood, DeltaDirection} from 'nutshell-core/types';

import {colors} from 'shells/colors/colors';

import styles from './tooltips.module.css';

type TooltipDeltasProps = {
    deltaRows: Array<{
        name: string;
        current: number;
        reference: number;
        isTotal: boolean;
    }>;
};

export function TooltipDeltas({deltaRows}: TooltipDeltasProps) {
    return (
        <div className={styles['tooltip-deltas-container']}>
            <h4 className={styles['tooltip-heading']}>&nbsp;</h4>
            <table className={styles['tooltip-table']}>
                <tbody>
                    {deltaRows.map((row) => {
                        const delta =
                            row.reference !== 0
                                ? Math.abs(
                                      Math.round(
                                          ((row.current - row.reference) / row.reference) * 100
                                      )
                                  )
                                : null;
                        let deltaMood = 'neutral';
                        let deltaDirection = 'neutral';
                        if (row.current > row.reference) {
                            deltaMood = 'positive';
                            deltaDirection = 'up';
                        }
                        if (row.current < row.reference) {
                            deltaMood = 'negative';
                            deltaDirection = 'down';
                        }

                        return (
                            <tr
                                key={row.name}
                                className={row.isTotal ? styles['row--total'] : undefined}
                            >
                                <td style={{display: 'flex'}}>
                                    <DeltaTriangle
                                        // @ts-expect-error
                                        deltaMood={deltaMood}
                                        // @ts-expect-error
                                        deltaDirection={deltaDirection}
                                    />
                                    {/* @ts-expect-error */}
                                    <DeltaValue delta={delta} deltaMood={deltaMood} />
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
}

type DeltaTriangleProps = {
    deltaMood: DeltaMood;
    deltaDirection: DeltaDirection;
};
const DeltaTriangle = ({deltaMood, deltaDirection}: DeltaTriangleProps) => {
    if (deltaMood === 'neutral') return null;

    const color = deltaMood === 'positive' ? colors.green : colors.rose;

    return (
        <div style={{width: 10}}>
            <svg fill={color} viewBox='-50 0 100 70'>
                {deltaDirection === 'up' ? (
                    <path d='M -50 50 L 0 0 L 50 50 L -50 50' />
                ) : (
                    <path d='M -50 0 L 0 50 L 50 0 L -50 0' />
                )}
            </svg>
        </div>
    );
};

type DeltaValueProps = {
    delta: number | null | undefined;
    deltaMood: DeltaMood;
};
const DeltaValue = ({delta, deltaMood}: DeltaValueProps) => {
    if (delta !== null) {
        const className = classnames({
            [styles['tooltip-delta-value']]: deltaMood === 'neutral',
            [styles['tooltip-delta-value--positive']]: deltaMood === 'positive',
            [styles['tooltip-delta-value--negative']]: deltaMood === 'negative',
        });

        return <span className={className}>{delta}%</span>;
    }

    return <span>&nbsp;</span>;
};
